import { IxMenu } from './IxMenu.js';

window.customElements.define('ix-menu', IxMenu);
